import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Otp, OtpFormComponent } from '@libs/authentication';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { TranslatePipe } from '@ngx-translate/core';
import { BaaSignupFlowService } from '../baa-sign-up-flow.service';

@Component({
  selector: 'lib-baa-signup-otp',
  imports: [TranslatePipe, OtpFormComponent],
  templateUrl: './baa-sign-up-otp.component.html',
  styleUrl: './baa-sign-up-otp.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaSignupOtpComponent implements OnInit, OnDestroy {
  protected readonly service = inject(BaaSignupFlowService);
  protected readonly routes = routes;
  protected readonly ffdNotesRoutePrefix = ffdNotesRoutePrefix;
  private readonly router = inject(Router);

  public ngOnInit(): void {
    if (!this.service.registrationTokenSignal() && !this.service.invitationTwoFaTokenSignal()) {
      this.router.navigate([...ffdNotesRoutePrefix(), routes.baaSignupFlow]);
    }
  }

  public ngOnDestroy(): void {
    this.service.resetOtpVerification();
  }

  protected onVerifyOtp(otp: Otp): void {
    if (!otp.code) return;
    this.service.verifyOtp({ otp: otp.code });
  }

  protected onResendOtp(): void {
    this.service.resendOtp();
  }
}
